/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * HTTP method used to probe the container.
 *
 * @remarks
 */
export const EnvironmentHealthcheckMethod = {
  Get: "GET",
  Post: "POST",
} as const;
/**
 * HTTP method used to probe the container.
 *
 * @remarks
 */
export type EnvironmentHealthcheckMethod = ClosedEnum<
  typeof EnvironmentHealthcheckMethod
>;

export type EnvironmentHealthcheck = {
  /**
   * HTTP method used to probe the container.
   *
   * @remarks
   */
  method: EnvironmentHealthcheckMethod;
  /**
   * HTTP path probed on the container. Must start with a slash.
   *
   * @remarks
   */
  path: string;
  /**
   * How often the probe runs, in seconds. Defaults to 10 when omitted.
   *
   * @remarks
   */
  intervalSeconds?: number | undefined;
  /**
   * Per-probe timeout, in seconds. Defaults to 5 when omitted.
   *
   * @remarks
   */
  timeoutSeconds?: number | undefined;
  /**
   * Consecutive failures before the container is restarted. Defaults to 3 when omitted.
   *
   * @remarks
   */
  failureThreshold?: number | undefined;
  /**
   * Delay before the first probe runs, in seconds. Defaults to 0 when omitted.
   *
   * @remarks
   */
  initialDelaySeconds?: number | undefined;
};

/** @internal */
export const EnvironmentHealthcheckMethod$inboundSchema: z.ZodNativeEnum<
  typeof EnvironmentHealthcheckMethod
> = z.nativeEnum(EnvironmentHealthcheckMethod);
/** @internal */
export const EnvironmentHealthcheckMethod$outboundSchema: z.ZodNativeEnum<
  typeof EnvironmentHealthcheckMethod
> = EnvironmentHealthcheckMethod$inboundSchema;

/** @internal */
export const EnvironmentHealthcheck$inboundSchema: z.ZodType<
  EnvironmentHealthcheck,
  z.ZodTypeDef,
  unknown
> = z.object({
  method: EnvironmentHealthcheckMethod$inboundSchema,
  path: z.string(),
  intervalSeconds: z.number().int().optional(),
  timeoutSeconds: z.number().int().optional(),
  failureThreshold: z.number().int().optional(),
  initialDelaySeconds: z.number().int().optional(),
});
/** @internal */
export type EnvironmentHealthcheck$Outbound = {
  method: string;
  path: string;
  intervalSeconds?: number | undefined;
  timeoutSeconds?: number | undefined;
  failureThreshold?: number | undefined;
  initialDelaySeconds?: number | undefined;
};

/** @internal */
export const EnvironmentHealthcheck$outboundSchema: z.ZodType<
  EnvironmentHealthcheck$Outbound,
  z.ZodTypeDef,
  EnvironmentHealthcheck
> = z.object({
  method: EnvironmentHealthcheckMethod$outboundSchema,
  path: z.string(),
  intervalSeconds: z.number().int().optional(),
  timeoutSeconds: z.number().int().optional(),
  failureThreshold: z.number().int().optional(),
  initialDelaySeconds: z.number().int().optional(),
});

export function environmentHealthcheckToJSON(
  environmentHealthcheck: EnvironmentHealthcheck,
): string {
  return JSON.stringify(
    EnvironmentHealthcheck$outboundSchema.parse(environmentHealthcheck),
  );
}
export function environmentHealthcheckFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentHealthcheck, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentHealthcheck$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentHealthcheck' from JSON`,
  );
}
